"use client";
import "./chunk-N3ETBM74.js";
import { useEffect, useState } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { msalAuthSettings } from "./msal";
const deriveBadgeLetter = (claims) => {
  if (claims == null ? void 0 : claims.given_name) return claims.given_name.slice(0, 1).toUpperCase();
  if (claims == null ? void 0 : claims.email) return claims.email.slice(0, 1).toUpperCase();
  return "";
};
const useBadgeLetter = () => {
  const { inProgress, instance } = useMsal();
  const [badgeLetter, setBadgeLetter] = useState("");
  useEffect(() => {
    if (inProgress !== InteractionStatus.None) return;
    instance.acquireTokenSilent({ scopes: msalAuthSettings.scopes }).then((result) => {
      var _a;
      return setBadgeLetter(deriveBadgeLetter((_a = result.account) == null ? void 0 : _a.idTokenClaims));
    }).catch(() => {
      var _a;
      return setBadgeLetter(deriveBadgeLetter((_a = instance.getActiveAccount()) == null ? void 0 : _a.idTokenClaims));
    });
  }, [inProgress, instance]);
  return badgeLetter;
};
export {
  useBadgeLetter
};
